import React from 'react';
import { ApSecondaryNav, ApButtonTab } from '@alixpartners/ui-components';
import { NavLink, useLocation } from 'react-router-dom';
import { MARKET_ANALYSIS_NAV_CONFIG } from 'SupplierDiversity/utils';

export const SecondaryNav = () => {
	const location = useLocation();
	return (
		<ApSecondaryNav
			left={MARKET_ANALYSIS_NAV_CONFIG.map(
				({ label, path, disabled, lastRoute }) => (
					<NavLink to={path} key={path} disabled={disabled}>
						<ApButtonTab
							isSelected={location.pathname.split('/').includes(lastRoute)}
							disabled={disabled}
						>
							{label}
						</ApButtonTab>
					</NavLink>
				)
			)}
		/>
	);
};

export default SecondaryNav;
